@if (isLoading) {
  <div class="loading-wrap">
    <mat-spinner diameter="40"></mat-spinner>
  </div>
} @else if (!accessDenied) {
<div class="container">
  <h1>Pagamentos</h1>
  <p class="subtitle mat-mdc-typography-body-large">
    Lista de pagamentos finalizados, vencidos ou pendentes
  </p>

  <mat-card class="delay-notice" appearance="outlined">
    <mat-card-content>
      <mat-icon class="delay-icon">schedule</mat-icon>
      <span>
        O status do pagamento pode levar alguns instantes para ser atualizado após a conclusão no
        meio de pagamento.
      </span>
    </mat-card-content>
  </mat-card>

  @if (payments.length === 0) {
      <p class="empty-message">Nenhum pagamento encontrado.</p>
    } @else {
      <table mat-table [dataSource]="payments" class="mat-elevation-z2 full-width">
        <ng-container matColumnDef="paymentId">
          <th mat-header-cell *matHeaderCellDef>ID do pagamento</th>
          <td mat-cell *matCellDef="let row">{{ row.paymentId ?? '—' }}</td>
        </ng-container>

        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef>Status</th>
          <td mat-cell *matCellDef="let row">{{ paymentStatusLabel(row.status) }}</td>
        </ng-container>

        <ng-container matColumnDef="dueDate">
          <th mat-header-cell *matHeaderCellDef>Data de vencimento</th>
          <td mat-cell *matCellDef="let row">
            @if (row.dueDate) {
              {{ row.dueDate | date: 'dd/MM/yyyy HH:mm' }}
            } @else {
              —
            }
          </td>
        </ng-container>

        <ng-container matColumnDef="paymentDate">
          <th mat-header-cell *matHeaderCellDef>Data do pagamento</th>
          <td mat-cell *matCellDef="let row">
            @if (row.paymentDate) {
              {{ row.paymentDate | date: 'dd/MM/yyyy HH:mm' }}
            } @else {
              —
            }
          </td>
        </ng-container>

        <ng-container matColumnDef="value">
          <th mat-header-cell *matHeaderCellDef>Valor</th>
          <td mat-cell *matCellDef="let row">
            @if (row.value != null) {
              {{ row.value | currency: 'BRL' }}
            } @else {
              —
            }
          </td>
        </ng-container>

        <ng-container matColumnDef="paymentLink">
          <th mat-header-cell *matHeaderCellDef>Link para pagamento</th>
          <td mat-cell *matCellDef="let row">
            @if (row.paymentLink) {
              <a [href]="row.paymentLink" target="_blank" rel="noopener noreferrer">Link de pagamento</a>
            } @else {
              —
            }
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>

      <mat-paginator
        [length]="totalElements"
        [pageSize]="pageSize"
        [pageIndex]="pageIndex"
        [pageSizeOptions]="[5, 10, 25, 100]"
        (page)="onPageChange($event)"
        showFirstLastButtons
        aria-label="Selecione a página">
      </mat-paginator>
    }
</div>
}
